var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.297 17.71L15.56 24.45c-1.412 1.411-1.546 3.565-.3 4.811s3.4 1.112 4.812-.3L22.029 27m-1.504-1.5l.975-.975m.529-6.545l.752-.753a2.127 2.127 0 113.008 3.009L24.525 21.5m-8.513-.512l6.769-6.769a4.254 4.254 0 116.016 6.017L27 22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25h2M25 26v-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgAttach;